import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus, UploadProgress } from 'ngx-uploader';

import { FileManagerService } from '../file-manager.service';
import { FileCameraUploadComponent } from '../file-manager-view/file-camera-upload/file-camera-upload.component';
import { DocumentUploadModel } from 'src/app/models/document/document-upload.model';
import { FileHelperService } from 'src/app/services/file-helper.service';
import { DocumentFileTypeEnum } from 'src/app/models/enum/document/document-file-type.enum';
import { DocumentClassEnum } from 'src/app/models/enum/document/document-class.enum';

@Component({
  selector: 'app-file-manager-upload',
  templateUrl: './file-manager-upload.component.html',
  styleUrls: ['./file-manager-upload.component.css']
})
export class FileManagerUploadComponent implements OnInit {

  fileToUpload: File = null;
  fileStatus: any = {};
  fileData: any = {};

  showError: boolean = false;
  error: string = '';
  url: string = "/api/document/uploadDocuments";
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;
  authToken: string = "";
  webcamUploadId: string = "";

  constructor(
    private fileManagerService: FileManagerService,
    private fileHelperService: FileHelperService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FileManagerUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.options = { concurrency: 1, maxUploads: 30, maxFileSize: 2097152000 };
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
    this.fileData = this.data;
  }

  onUploadOutput(output: UploadOutput): void {
    console.log('onUploadOutput: ', output);
    console.log('onUploadOutput typeof output.file: ', typeof output.file);

    if (typeof output.file !== 'undefined' && output.file.type === "") {
      this.showError = true;
      this.error = 'Unsupported  file type detected'
      this.files = this.files.filter(file => file.id !== output.file.id);
    }

    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: 'uploadAll',
        url: this.url,
        headers: { 'Authorization': 'bearer ' + this.authToken },
        method: 'POST',
        data: this.fileData,
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.fileStatus[index] = {
        processing: true
      };
      this.files[index] = output.file;
    } else if (output.type === 'cancelled' || output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.fileStatus[index] = {
        processing: false,
        error: 'File Rejected'
      };
      this.files[index] = output.file;

      console.log(output.file.name + ' rejected. ', index);
      console.log('this.fileStatus[index]: ', this.fileStatus[index]);
      console.log('this.files[index]: ', this.files[index]);
    } else if (output.type === 'done' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      if (this.fileStatus[index]) {

        if (output.file.responseStatus == 200) {
          this.fileStatus[index].processing = false;
          this.fileStatus[index].error = false;
        }
        else
          this.fileStatus[index].error = "Error " + output.file.response.Message;
      }
    }
  }

  closeRef() {
    this.dialogRef.close(true);
  }

  ngOnInit() {
    if (localStorage.getItem('TDOauthToken')) {
      this.authToken = localStorage.getItem('TDOauthToken');
    } else if (localStorage.getItem('TDOPatientAuthToken')) {
      this.authToken = localStorage.getItem('TDOPatientAuthToken');
    }
  }

  getNextWebcamFileId() {
    //var webcamUploads = this.files.find(f => f.id.startsWith("WebcamUpload"));
    if (this.webcamUploadId === "")
      return "WebcamUpload001";
    let currentId: number = Number(this.webcamUploadId.slice(-3));
    currentId++;
    return `WebcamUpload${String(currentId).padStart(3, "0")}`;
  }

  openCameraModule() {
    const dialogRef = this.dialog.open(FileCameraUploadComponent, {
      width: '900px',
      height: '700px',
      data: {
        patientId: this.fileData.PatientId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("FileManagerUploadComponent openCameraModule afterClosed", result);
      if (result) {
        this.webcamUploadId = this.getNextWebcamFileId()
        const uploadStart: UploadProgress = { status: 0 }
        const uploadFile: UploadFile = {
          id: this.webcamUploadId,
          fileIndex: 0,
          lastModifiedDate: new Date(),
          name: `${this.webcamUploadId}.jpg`,
          size: result.size,
          type: 'image/jpeg',
          form: new FormData(),
          progress: uploadStart,
          //nativeFile:  this.blobToFile(result, "WebUpload001.jpg"),
        }
        const uploadOutput: UploadOutput = {
          type: 'addedToQueue',
          file: uploadFile
        }
        this.onUploadOutput(uploadOutput);

        this.fileHelperService.getDataAndThumbnailFromFile(this.blobToFile(result, `${this.webcamUploadId}.jpg`)).subscribe((mod) => {
          const fileModel = mod;
          const uploadModel = new DocumentUploadModel();
          uploadModel.blob = fileModel.fileDataBlob;
          uploadModel.blobThumbnail = fileModel.thumbnailDataBlob;
          uploadModel.patientId = this.fileData.PatientId;
          uploadModel.docTypeId = this.fileData.enumDocumentTypeID;
          uploadModel.hasAnnotation = false;
          uploadModel.docTagIds = this.fileData.enumDocumentTags;
          uploadModel.docClassId = DocumentClassEnum.Original;

          switch (fileModel.fileMimeType) {
            case FileHelperService.MIME_JPG:
            case FileHelperService.MIME_PNG:
              uploadModel.docFileTypeId = DocumentFileTypeEnum.JPG;
              break;
          }

          uploadModel.patientId = this.fileData.PatientId;

          this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
            console.log("Uploaded file response: ", response);
            const dataProgress = {
              percentage: 100,
              speed: 1,
              speedHuman: "Mbps",
              startTime: null,
              endTime: null,
              eta: null,
              etaHuman: null
            };
            const uploadStart: UploadProgress = { status: 1, data: dataProgress }
            const uploadFile: UploadFile = {
              id: this.webcamUploadId,
              fileIndex: 0,
              lastModifiedDate: new Date(),
              name: `${this.webcamUploadId}.jpg`,
              size: result.length,
              type: 'image/jpeg',
              form: new FormData(),
              progress: uploadStart,
              responseStatus: 200
            }
            const uploadOutput: UploadOutput = {
              type: 'uploading',
              file: uploadFile

            }
            this.onUploadOutput(uploadOutput);

            const res = response.documents[0];

            this.fileManagerService.addMultiDocumentsTags([res.DocumentID], [this.fileData.enumDocumentTags], null, this.fileData.PatientId).subscribe((responseAddTag) => {
              const dataProgress = {
                percentage: 100,
                speed: 1,
                speedHuman: "Mbps",
                startTime: null,
                endTime: null,
                eta: null,
                etaHuman: null
              };
              const uploadStart: UploadProgress = { status: 2, data: dataProgress }
              const uploadFile: UploadFile = {
                id: this.webcamUploadId,
                fileIndex: 0,
                lastModifiedDate: new Date(),
                name: `${this.webcamUploadId}.jpg`,
                size: result.length,
                type: 'image/jpeg',
                form: new FormData(),
                progress: uploadStart,
                responseStatus: 200
              }
              const uploadOutput: UploadOutput = {
                type: 'done',
                file: uploadFile

              }
              this.onUploadOutput(uploadOutput);
            });
          }, err => {
            const dataProgress = {
              percentage: 0,
              speed: 1,
              speedHuman: "Cancelled",
              startTime: null,
              endTime: null,
              eta: null,
              etaHuman: null
            };
            const uploadStart: UploadProgress = { status: 3, data: dataProgress }

            const uploadFile: UploadFile = {
              id: this.webcamUploadId,
              fileIndex: 0,
              lastModifiedDate: new Date(),
              name: `${this.webcamUploadId}.jpg`,
              size: result.length,
              type: 'image/jpeg',
              form: new FormData(),
              progress: uploadStart,
              responseStatus: 200
            }
            const uploadOutput: UploadOutput = {
              type: 'rejected',
              file: uploadFile

            }
            console.log("Error Uploaded file: ", uploadOutput);

            this.onUploadOutput(uploadOutput);
            console.log(err);
          });
        });
      }
    },
      err => { });

  }

  blobToFile(theBlob, fileName) {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob as File;
  }

}
